<template>
  <div class="new-era">
    <div class="p-top-wrapper">
      <div class="p-top">
        <div class="p-left" @click="gohome">
          <img :src="require('@/assets/img/common/back_home@2x.png')" alt="" class="p-image-home" />
          <div class="p-backtips">返回首页</div>
        </div>
        <div class="p-arrow-tips"> > </div>
        <div class="p-map-tips">晋中故事</div>
      </div>
    </div>

    <div class="new-era-content">
      <div class="new-era-content-top">
        <div class="nect-title">
          晋中故事
        </div>
        <div class="nect-search">
          <div class="nect-search-content">
            <a-input v-model="inputValue" placeholder="搜索你想知道的..." style="width: 410px"/>
            <div class="nect-search-button" @click="search">搜索</div>
          </div>

        </div>
      </div>
      <div class="new-era-content-list">
        <NewList :newList="newList" :siteName="siteName" :total="total" @page="pageChange"/>
      </div>
    </div>
  </div>
</template>

<script>
import NewList from '../../../components/common/NewList'
import moment from 'moment'

export default {
  components:{NewList},
  data(){
    return{
      inputValue:'',
      siteName:'jz-story',
      newList:[],
      secondParam:{
        siteId:process.env.VUE_APP_siteId,//'1637056442198bfbe7eaff903420a996db1b9c5fc22cb',
        typeCode:'half_moon'
      },
      pageParam:{
        page:1,
        pageSize:10,
        type:'half_moon'
      },
      total:0
    }
  },
  mounted() {
    this.getSecondType()
  },
  methods:{
    pageChange(e){
      this.pageParam.page=e
      this.getNewsList()
    },

    gohome() {
      this.$EventBus.$emit("gotoPanel", { key: "home" });
      this.$router.push('/')
    },
    search(){
      this.pageParam['title']=this.inputValue;
      this.pageParam.page=1;
      this.getNewsList()
    },
    getSecondType() {
      this.$api.xsdapi
          .secondType(this.secondParam)
          .then(res=>{
            if (res && res.length > 0) {
              for (let i = 0; i < res.length; i++) {
                const element = res[i];
                if (element.secondTypeName === '晋中故事') {
                  this.pageParam['siteId'] = element.siteId;
                  this.pageParam['secondType'] = element._id;
                  this.getNewsList();
                  break;
                }
              }
            }
          })
    },
    getNewsList(){
      this.$api.xsdapi
          .newsList(this.pageParam)
          .then(res=>{
            let list = res.data;
            list && list.length > 0 && (list.forEach(item => item.publishTime && (item.publishTime = moment(item.publishTime).format('YYYY-MM-DD'))))
            this.newList = list;
            this.total = res.total;
          })
    },
  }
}
</script>

<style lang="scss" scoped>
.p-top-wrapper{
  width: 1200px;
  position: relative;
  left: 50%;
  transform: translateX(-50%);
  top:20px;
}
.p-top {
  marign:20px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #222222;
  line-height: 16px;
  margin-bottom: 57px;
  .p-left {
    cursor: pointer;
    display: flex;
    align-items: center;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #222222;
    line-height: 16px;
    .p-image-home {
      width: 26px;
      height: 26px;
      margin-right: 6px;
    }
  }
  .p-arrow-tips {
    margin: 0 5px;
  }
  .p-map-tips {
    cursor: pointer;
    color: #CD3232;
  }
}
.new-era{
  width: 100%;
  height:auto;
  background: #fbfbfb;
}
.new-era-content{
  width: 1200px;
  position: relative;
  left:50%;
  transform: translateX(-50%);
  margin-top:20px;

  .new-era-content-top{
    background: #FFFFFF;
    width:1200px;
    bejgbt:143px;
    text-align: left;

    .nect-title{
      font-size: 20px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      line-height: 20px;
      padding:20px 16px;

      &::before{
        content: '';
        display: inline-block;
        width: 4px;
        height: 16px;
        background: #CD3232;
      }
    }

    .nect-search{
      border-top: 1px solid #cd3232;
      .nect-search-content{
        display: flex;
        flex-direction: row;
        margin-left: 700px;
        align-items: center;
        margin-top: 20px;
        .nect-search-button{
          margin-left: 20px;
          width: 90px;
          height: 32px;
          background: #CD3232;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 14px;
          font-family: Helvetica;
          color: #FFFFFF;
          line-height: 14px;
        }
      }
    }
  }

}
</style>